import gql from "graphql-tag";
import {useCallback} from "react";

import {useGql} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {RestorableCoeditingSnapshot} from "../types.ts";

import type {coeditingLatestSnapshotType} from "./__graphql-types__/index.ts";

const COEDITING_LATEST_SNAPSHOT_QUERY: GqlOperation<
    coeditingLatestSnapshotType["response"],
    coeditingLatestSnapshotType["variables"]
> = gqlOp(gql`
    query coeditingLatestSnapshot($threadId: String!) {
        aiGuideThread(threadId: $threadId) {
            id
            coeditingDocument {
                id
                title
                latestSnapshot {
                    id
                    text {
                        prefix
                        selection
                        suffix
                    }
                }
            }
        }
    }
`);

export default function useGetLatestSnapshot(): (
    threadId: string,
) => Promise<void | RestorableCoeditingSnapshot> {
    const gqlFetch = useGql();

    const sendQuery = useCallback(
        async (threadId: string) => {
            if (!threadId) {
                return;
            }

            const response = await gqlFetch(COEDITING_LATEST_SNAPSHOT_QUERY, {
                variables: {threadId},
            });

            const doc = response.aiGuideThread?.coeditingDocument;
            if (!doc) {
                return;
            }

            const {title, latestSnapshot} = doc;
            if (!latestSnapshot) {
                return;
            }

            const {text} = latestSnapshot;
            const {prefix = "", selection = "", suffix = ""} = text;

            return {title, prefix, selection, suffix};
        },
        [gqlFetch],
    );

    return sendQuery;
}
